import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, Teleport as _Teleport, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_2 = { class: "heading-m" }
const _hoisted_3 = { class: "audit-logs__controls" }
const _hoisted_4 = { class: "audit-logs__scrollable label-mono-xs" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FiltersSmall = _resolveComponent("FiltersSmall")!
  const _component_FiltersBig = _resolveComponent("FiltersBig")!
  const _component_NTable = _resolveComponent("NTable")!
  const _component_NButton = _resolveComponent("NButton")!
  const _component_Sidebar = _resolveComponent("Sidebar")!
  const _component_ListPage = _resolveComponent("ListPage")!
  const _component_NIcon = _resolveComponent("NIcon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ListPage, {
      state: _ctx.state,
      statistics: false,
      "onUpdate:scrollBottom": _ctx.scrollBottomHandler
    }, {
      filters: _withCtx(() => [
        _createVNode(_component_FiltersSmall, {
          "form-layout": _ctx.smallFilterSchema,
          state: _ctx.state,
          "has-changes": _ctx.module.filter.hasChanges,
          onOpenFilters: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isFilterVisible = true)),
          onResetFilters: _ctx.resetFilters,
          "data-qa": "audit_logs.small-filters",
          modelValue: _ctx.module.filter.current,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.module.filter.current) = $event)),
          "has-report": "",
          enabledFields: _ctx.smallFilterFields,
          "onUpdate:enabledFields": _cache[2] || (_cache[2] = (v) => _ctx.setSmallFilterFields(v))
        }, null, 8, ["form-layout", "state", "has-changes", "onResetFilters", "modelValue", "enabledFields"]),
        (_ctx.isFilterVisible)
          ? (_openBlock(), _createBlock(_component_FiltersBig, {
              key: 0,
              "form-layout": _ctx.bigFilterSchema,
              state: _ctx.state,
              onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isFilterVisible = false)),
              onResetFilters: _ctx.resetFilters,
              "has-report": "",
              modelValue: _ctx.module.filter.current,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.module.filter.current) = $event)),
              enabledFields: _ctx.smallFilterFields,
              "onUpdate:enabledFields": _cache[5] || (_cache[5] = (v) => _ctx.setSmallFilterFields(v))
            }, null, 8, ["form-layout", "state", "onResetFilters", "modelValue", "enabledFields"]))
          : _createCommentVNode("", true)
      ]),
      summary: _withCtx(() => [
        _hoisted_1
      ]),
      items: _withCtx(() => [
        _createVNode(_component_NTable, {
          class: "audit-logs__table",
          columns: _ctx.tableSchema,
          content: _ctx.items,
          "data-qa": "audit_logs.table",
          onCellClick: _ctx.handleTableAction
        }, null, 8, ["columns", "content", "onCellClick"])
      ]),
      sidebar: _withCtx(() => [
        _createVNode(_component_Sidebar, { class: "audit-logs__sidebar" }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('audit_logs.details', 'f')), 1),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_NButton, {
                type: "secondary",
                icon: "copy",
                onClick: _ctx.copyText
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('audit_logs.copy', 'f')), 1)
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_NButton, {
                type: "secondary",
                round: "",
                icon: "close",
                onClick: _ctx.closeSideBar
              }, null, 8, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("pre", _hoisted_4, _toDisplayString(_ctx.auditLogsItemContent), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["state", "onUpdate:scrollBottom"]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createElementVNode("div", {
        class: _normalizeClass([{ 'audit-logs_visible_noty': _ctx.visibleNoty }, "audit-logs__notification heading-m"])
      }, [
        _createVNode(_component_NIcon, { name: "info" }),
        _createTextVNode(_toDisplayString(_ctx.$t('audit_logs.clipboard_success', 'f')), 1)
      ], 2)
    ]))
  ], 64))
}